<template>
  <div class="header">
    <div class="left-slot">
      <i v-if="headerConfig.back || $route.meta.isBack" class="el-icon-back" @click="$router.go(-1)"></i>
    </div>
    <span v-if="!$route.meta.title">{{ $store.state.project.name }}</span>
    <span v-else>{{
        $route.meta.replacedType &&
        $route.params.type ?
        tr[$route.params.type] :
        $route.meta.title
      }}</span>

    <div class="right-slot">
      <component v-if="headerConfig.rightComponent" :is="headerConfig.rightComponent"/>
    </div>
  </div>
</template>

<script>
import AddJob from './AddJob';

export default {
  name: 'Header',

  components: {AddJob},

  data() {
    return {
      routers: {
        jobs: {
          back: true,
          rightComponent: 'AddJob',
        },
        objects: {
          back: true,
        },
        jobCreate: {
          back: true,
        },
      },

      tr: {
        line: 'Список линий',
        welder: 'Сварщики',
        welder_cons: 'Сварочные материалы',
        team: 'Бригадиры',
      },
    };
  },

  computed: {
    headerConfig() {
      return this.routers[this.$route.name] || {};
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  height: 50px;
  //padding-top: 30px; // IOS ONLY
  left: 0;
  top: 0;
  right: 0;
  z-index: 8;
  background-color: #3676CB;
  color: #fff;
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .el-icon-back {
    color: #ffffff;
    font-size: 28px;
    cursor: pointer;
  }

  .left-slot {
    width: 64px;
    margin-left: 64px;
  }

  .right-slot {
    width: 96px;
    margin-right: 32px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue